export const TipoDocumento = {
    CPF: 'CPF',
    CNPJ: 'CNPJ',
    INVALID: 'INVALID'
}